module.exports = __webpack_public_path__ + "static/media/mobileScreen.451634bd.jpg";